<template>
  <div id="user-home">
    <h1 class="title layout-spacing-big">Početna</h1>
    <div class="layout-spacing">
      <div class="grid">
        <ArrivalBanner v-if="features.arrivalTimeSlots" :configuration="configuration" />
        <ApplicationActiveEvent :activeEvents="activeEvents" v-if="activeEvents.length" />
        <div v-else></div>
        <ButtonLinks
          v-if="features.buttonLinks"
          :features="{
            workshops: features.workshops,
            jigsawSessions: features.jigsawSessions,
            arrivalTimeSlots: features.arrivalTimeSlots,
          }"
        />
        <div v-else></div>
        <!-- <FeaturedEvents :featuredEvents="featuredEvents" v-if="featuredEvents.length" /> -->
        <Newsboard :news="newsboardNotifications" v-if="newsboardNotifications.length" />
        <div v-else></div>
        <StreamLinks v-if="isStreamActive" />
        <div v-else></div>
      </div>
      <ScrollingLinks
        v-if="features.scrollingLinks"
        :features="{
          jigsawSessions: features.jigsawSessions,
          flyTalks: features.flyTalks,
          prizes: features.prizes,
        }"
      />
      <MapSection v-if="isMapActive" />
      <DiscordWidget v-if="isDiscordActive" />
    </div>
  </div>
</template>

<script>
import { mapIsActive, discordIsActive, streamIsActive } from '@/config';

import ButtonLinks from './Home/ButtonLinks';
import Newsboard from './Home/Newsboard';
import ScrollingLinks from './Home/ScrollingLinks';
import ArrivalBanner from './Home/ArrivalBanner';
import MapSection from './Home/MapSection';
import ApplicationActiveEvent from './Home/ApplicationActiveEvent';
import DiscordWidget from './Home/DiscordWidget';
import StreamLinks from './Home/StreamLinks.vue';

export default {
  name: 'Home',
  components: {
    ButtonLinks,
    Newsboard,
    ScrollingLinks,
    ArrivalBanner,
    MapSection,
    ApplicationActiveEvent,
    DiscordWidget,
    StreamLinks,
  },
  data() {
    return {
      activeEvents: [],
      newsboardNotifications: [],
      sponsors: [],
      eventForModal: {},
      userArrivalTimeSlot: null,
      detailsModalVisible: false,
      isMapActive: mapIsActive,
      isDiscordActive: discordIsActive,
      isStreamActive: streamIsActive,
      route: 'app/home',
      features: {},
      configuration: {},
    };
  },
  methods: {
    handleJigsawSessionModalToggle: function() {
      if (!this.jigsawSessionModalToggle) {
        document.querySelector('#user-navigation').classList.add('blurred');
        document.querySelector('#user-home').classList.add('blurred');
        document.body.classList.add('modal-open');
      } else {
        document.querySelector('#user-navigation').classList.remove('blurred');
        document.querySelector('#user-home').classList.remove('blurred');
        document.body.classList.remove('modal-open');
      }

      this.jigsawSessionModalToggle = !this.jigsawSessionModalToggle;
    },
    getLogo: function(sponsorName) {
      // eslint-disable-next-line
      return require(`../../assets/companies/logos/${this.getSponsorNameNormalized(sponsorName)}.png`);
    },
    getSponsorNameNormalized: function(sponsorName) {
      return sponsorName.replace(/\s/g, '').toLowerCase();
    },
    getUserArrivalTimeSlot: function() {
      this.$axios.get(`${this.$API_URL}/user/arrival-time-slot`).then(response => {
        this.userArrivalTimeSlot = response.data;
      });
    },
    signout: function() {
      localStorage.removeItem('token');
      this.$router.push('/');
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/features/route`, { params: { route: this.route } }).then(response => {
      this.features = response.data.features.reduce((acc, x) => {
        acc[x.path.replace(`${this.route}/`, '')] = x.isActive;

        return acc;
      }, {});
    });
    this.getUserArrivalTimeSlot();
    // this.$axios.get(`${this.$API_URL}/events/featured`).then(response => {
    // this.featuredEvents = response.data;
    // TODO
    // });
    this.$axios.get(`${this.$API_URL}/events/active-events`).then(response => {
      this.activeEvents = response.data;
    });
    this.$axios.get(`${this.$API_URL}/newsboard/active`).then(response => {
      this.newsboardNotifications = response.data;
    });
    this.$axios.get(`${this.$API_URL}/companies/all-sponsors`).then(response => {
      this.sponsors = response.data
        .filter(
          sponsor =>
            sponsor.sponsorCategory === 'General' ||
            sponsor.sponsorCategory === 'Gold' ||
            sponsor.sponsorCategory === 'Silver',
        )
        .sort((firstSponsor, secondSponsor) => (firstSponsor.name < secondSponsor.name ? -1 : 1));
    });
    this.$axios.get(`${this.$API_URL}/application-configuration`).then(response => {
      this.configuration = response.data;
    });
  },
};
</script>

<style scoped>
#user-home {
  padding: 48px 24px 100px;
}
#user-home.blurred {
  filter: blur(10px);
}
.title {
  margin-top: 0;
}
.header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.header img {
  height: 20px;
  margin-right: 15px;
}
.header img.settings,
.header img.signout {
  filter: invert(78%) sepia(9%) saturate(3087%) hue-rotate(121deg) brightness(92%) contrast(83%);
}
.header img.signout:hover {
  cursor: pointer;
}
.theme {
  color: white;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  margin-right: 10px;
  border-radius: 5px;
}
.theme.dev {
  background-color: #30cec1;
}
.theme.design {
  background-color: #ff575f;
}
.theme.tech {
  background-color: #2c373f;
}
.theme.marketing {
  background-color: #d6bd42;
}
.time {
  font-size: 14px;
  opacity: 0.5;
  margin-right: 15px;
}
.active-lectures {
  display: flex;
}
.active-lectures:after {
  content: '';
  flex: 0 0 10px;
}
.lecture-container {
  background-color: rgba(0, 0, 0, 0.015);
  border-radius: 7px;
  padding: 10px 10px 20px 10px;
  margin-right: 20px;
}
.active-label,
.next-label {
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.24px;
  margin-bottom: 5px;
}
.active-label {
  color: #30cec1;
  display: flex;
  align-items: center;
}
.active-label img {
  margin-right: 5px;
}
.next-label {
  color: #2c373f;
}
.lecture-header {
  color: black;
  display: flex;
  margin-bottom: 5px;
}
.lecture-title {
  color: black;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.2px;
  line-height: 24px;
}
.active-lectures {
  margin-top: 20px;
  overflow-x: auto;
}
.exhibition-areas-header {
  display: flex;
  font-size: 12px;
}
.exhibition-areas-header a {
  margin-left: auto;
  margin-right: 20px;
}
.exhibition-areas-header a span {
  color: black;
  opacity: 0.42;
  margin-right: 5px;
}
.exhibition-areas-sponsors {
  margin-top: 20px;
  padding-left: 10px;
  padding-right: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.exhibition-areas-sponsors div {
  flex-basis: 28%;
  margin-bottom: 20px;
}
.exhibition-areas-sponsors a img {
  width: 100%;
}
.atos img,
.bundesdruckerei img {
  transform: scale(0.6);
}
.hrprodigy img {
  transform: scale(1.1);
}
.extensionengine img {
  transform: scale(1.1);
}
.hrcloud img,
.infobip img,
.netmedia img {
  transform: scale(1.1);
}
.dobartek\.hr img {
  transform: scale(1.3);
}
.ericssonnikolatesla img {
  transform: scale(0.5);
}
.rimacautomobili img {
  transform: scale(1.4);
}
@media screen and (min-width: 1024px) {
  #user-home {
    padding: 160px 100px;
  }

  .grid {
    display: grid;
    grid-template-columns: 400px 400px;
    margin-bottom: 120px;
    justify-content: space-between;
  }

  .navigation-buttons {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
